import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as BellOffIcon } from './bellOff.svg';

export const BellOff = IconHOC(BellOffIcon);
